import { createContext } from "react";
import { initializeI18n } from "./initializeI18n";
export const UiI18nContext = createContext(initializeI18n({
    ns: [],
    defaultNS: false,
    lng: "en-US",
    resources: {},
}));
UiI18nContext.displayName = "UiI18nContext";
//# sourceMappingURL=UiI18nContext.js.map